(() => {
  if (!window.location.pathname.includes('/products/quad-short-2-0')) return;

  const PRODUCT_JSON = document.getElementById('quad-product-json');

  if (!PRODUCT_JSON) {
    console.warn('Quad liner fallback: product JSON not found.');
    return;
  }

  const product = JSON.parse(PRODUCT_JSON.textContent);

  const linerIndex = product.options.findIndex(
    option => option.toLowerCase() === 'liner'
  );

  if (linerIndex === -1) return;

  let switching = false;

  function findAlternateVariant(currentVariant) {
    if (!currentVariant) return null;

    return product.variants.find(variant => {
      if (!variant.available) return false;

      return variant.options.every((value, index) => {
        if (index === linerIndex) {
          return value !== currentVariant.options[index];
        }

        return value === currentVariant.options[index];
      });
    });
  }

function clickLiner(value) {
  const linerPosition = linerIndex + 1;

  // Only target the MAIN product form's liner radios
  const inputs = [
    ...document.querySelectorAll(
      `variant-picker input[type="radio"][data-option-position="${linerPosition}"][name*="product-form-main"]`
    )
  ];

  if (!inputs.length) {
    console.warn('Quad liner fallback: main Liner radios not found.');
    return false;
  }

  const targetInput = inputs.find(input => {
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (!label) return false;

    return (
      label.textContent.trim().toLowerCase() ===
      value.trim().toLowerCase()
    );
  });

  if (!targetInput) {
    console.warn(
      `Quad liner fallback: main ${value} input not found.`
    );
    return false;
  }

  console.log(
    'Quad liner fallback: switching to',
    value,
    targetInput.id
  );

  if (!targetInput.checked) {
    // Use the actual radio click so Prestige handles it exactly
    // like a customer clicking the swatch.
    targetInput.click();
  }

  return true;
}

  function correctVariant(variant) {
    if (switching || !variant || variant.available) return;

    const alternate = findAlternateVariant(variant);

    if (!alternate) {
      // Neither liner is available for this size/color.
      return;
    }

    const alternateLiner = alternate.options[linerIndex];

    switching = true;

    clickLiner(alternateLiner);

    setTimeout(() => {
      switching = false;
    }, 300);
  }

  /*
    Prestige v7+ officially emits this whenever its
    variant picker changes.
  */
  document.addEventListener('variant:change', event => {
    correctVariant(event.detail?.variant);
  });

  /*
    Handle the initial page load as well.
  */
  function checkInitialVariant() {
    const forms = [
      ...document.querySelectorAll('form[action*="/cart/add"]')
    ];

    for (const form of forms) {
      const idField = form.querySelector('[name="id"]');

      if (!idField?.value) continue;

      const variant = product.variants.find(
        v => String(v.id) === String(idField.value)
      );

      if (variant) {
        correctVariant(variant);
        return;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(checkInitialVariant, 500);
    });
  } else {
    setTimeout(checkInitialVariant, 500);
  }
})();